import React, { useEffect, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/draftSagas";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import TableWithCustomSearch from "../../../components/table/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";
import { UpdateButtons } from "./smartComponents/UpdateButtons";
import DatePicker from "./smartComponents/DatePicker";
import CustomDateRanges from "./smartComponents/CustomDateRanges";
import { DataPoints } from "./smartComponents/DataPoints";
import { DonutBreakdown } from "./smartComponents/DonutBreakdown";
import { AttemptsBreakdown } from "./smartComponents/AttemptsBreakdown";
import { DraftTypeFilter } from "./smartComponents/DraftTypeFilter";
import { DraftAttemptFilter } from "./smartComponents/DraftAttemptFilter";
import "./DraftModule.scss";

const DraftModule = (props) => {
  const dispatch = useDispatch();

  const initialRequest = useSelector((state) => state.draft.initialRequest);
  const isLoading = useSelector((state) => state.draft.isLoading);
  const updatesLoading = useSelector((state) => state.draft.updatesLoading);

  const { data, colHeaders, columns } = useSelector(
    (state) => state.draft.chartsData.table || {}
  );

  useEffect(() => {
    !initialRequest && dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  const content = (
    <div>
      <div id="override-edit-selection-bar" className="edit-selections-bar">
        <div className="top-filter">
          <div className="top-filter__left">
            <DraftTypeFilter />
            <DraftAttemptFilter />
          </div>
          <div />
          <div className="top-filter__right">
            <div className="select-box-no-width date-range-select-box">
              <p>Date Range</p>
              <CustomDateRanges />
            </div>

            <div className="date-select-box multi">
              <p>Date</p>
              <DatePicker />
            </div>
          </div>
        </div>

        <UpdateButtons />
      </div>
      <div data-testid="charts-container" className="chart-root">
        {updatesLoading ? (
          <LoadingAnimation text="Updating data..." />
        ) : (
          <>
            <DataPoints />
            <div className="section">
              <div className="section__el">
                <AttemptsBreakdown />
              </div>
              <div className="section__el">
                <DonutBreakdown />
              </div>
            </div>

            {data && data.length > 0 && (
              <TableWithCustomSearch
                fileName="draft-details"
                data={data}
                columns={columns}
                colHeaders={colHeaders}
                itemsPerPage={10}
              />
            )}
          </>
        )}
      </div>
    </div>
  );

  return (
    <div id="module-date-filters">
      <div id="draft-module">
        <SectionToggle
          height={690}
          title="Draft"
          isLoading={isLoading}
          content={content}
        />
      </div>
    </div>
  );
};

export default memo(DraftModule);
